<script>
import ModalSimulatorQuestionCategoryComponent from '../../features/modals/ModalSimulatorQuestionCategoryComponent';
export default {
  name: 'ModalSimulatorQuestionCategoryView',
  extends: ModalSimulatorQuestionCategoryComponent,
};
</script>

<template>
  <el-dialog
    v-model="conf.isVisible"
    title="Categoria de Pregunta"
    width="30%"
    class="simulator-question-category-modal"
    append-to-body
    :before-close="onCancel"
    :close-on-click-modal="false"
  >
    <el-form
      ref="formData"
      v-loading="conf.isLoading"
      :model="formData"
      :rules="rules"
      status-icon
      :label-position="'top'"
    >
      <fieldset>
        <legend>Información de Categoria</legend>
        <el-row
          type="flex"
          class="row-bg"
          :gutter="20"
        >
          <el-col :span="24">
            <el-form-item
              label="Código"
              prop="code"
            >
              <el-input
                v-model="formData.code"
                size="small"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          class="row-bg"
          :gutter="20"
        >
          <el-col :span="24">
            <el-form-item
              label="Nombre"
              prop="name"
            >
              <el-input
                v-model="formData.name"
                maxlength="70"
                size="small"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          class="row-bg"
          :gutter="20"
        >
          <el-col :span="24">
            <el-form-item
              label="Descripción"
              prop="description"
            >
              <el-input
                v-model="formData.description"
                maxlength="155"
                size="small"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </fieldset>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button
          size="small"
          class="btn-cancel"
          @click="onCancel"
        >Cancelar</el-button>
        <el-button
          type="primary"
          :disabled="!onCanSaveOrUpdate()"
          class="btn-primary"
          size="small"
          @click="onSubmitForm('formData')"
        >Guardar</el-button>
      </span>
    </template>
  </el-dialog>
</template>